// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileMain_wrapper__blYox","greeting":"ProfileMain_greeting__CGfCR","title":"ProfileMain_title__n--Is","text":"ProfileMain_text__gVx8g"};